import React from 'react';
import { document_sign_url } from '../../common/constants/allowed_iframe_urls';
import { useParams } from 'react-router-dom';
import { DocumensoFrame } from '../../common/main-navigation/components/DocumensoFrame';

const SigningPage = () => {
  const { documentId } = useParams();
  return <DocumensoFrame url={document_sign_url(documentId)} title='Signing' />;
};

export default SigningPage;
